module.exports = __webpack_public_path__ + "img/ico05.8676ae44.svg";